import { render, staticRenderFns } from "./negotiateLive.vue?vue&type=template&id=4b4f7141&scoped=true"
import script from "./negotiateLive.vue?vue&type=script&lang=js"
export * from "./negotiateLive.vue?vue&type=script&lang=js"
import style0 from "./negotiateLive.vue?vue&type=style&index=0&id=4b4f7141&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4f7141",
  null
  
)

export default component.exports